export default __webpack_public_path__ + "61cac1eaec6b8110e24f67eddc8b28bc.png";